export default "/_next/static/chunks/fonts/Roboto-Medium-latin-a1ae85208521fce59e29744c2c3f1f36.woff2";